import React from 'react';
import Button from 'b2b-ui-components-lib/lib/components/button';
import '../index.scss';
import ReferBusiness from 'featureLib/ReferBusiness';
import NextSteps from 'featureLib/NextSteps';
import ExploreProducts from 'featureLib/ExploreProducts';
import { getProductDisplayName, getProductType } from 'common/constants/app.constants';
import { redirectToTMO, redirectToTMODashboard } from 'home/view/manage-feasibility/utils';
import { convertTimeStamp } from 'common/utils/app.utils';

export const AuthThanksPage = (props: any) => {
  const { isUpgrade, userType, isMultiSite, product, leadId, noOfCircuits, dateStamp } = props;
  const currentProduct = product || getProductType();
  const productName = getProductDisplayName(currentProduct);

  const getMessageBody = () => {
    if (userType === 'KAM') {
      return `Your booking order for the Airtel ${productName} Plan has been approved.`;
    }
    if (userType === 'ENTERPRISE') {
      return `Your order for the ${isMultiSite ? 'multiple' : ''} Airtel ${productName} has been successfully submitted.`;
    }
    if (isUpgrade) {
      return `Your upgrade request for the multiple circuits of ${productName} has been successfully submitted. An e-mail has been sent to you along with the pricing
      quotation.`;
    } else {
      return `Your order for the ${isMultiSite ? 'multiple' : ''} Airtel ${productName} has been successfully submitted.`;
    }
  };

  return (
    <div className="thanks_page">
      <div className="container">
        <div className="thanks_wrapper">
          <div className="thanks_left">
            <div className="thanks-content">
              <div className="head-title">
                <div className="checkmark_box">
                  <div className="check"></div>
                </div>
                {userType === 'KAM' ? (
                  <h2>
                    Thank you! <br /> Request approved successfully.
                  </h2>
                ) : isUpgrade ? (
                  <h2>Thank you for choosing Airtel!!</h2>
                ) : (
                  <h2>Your request has been raised successfully!</h2>
                )}
              </div>
              <p className="title-subtext">
                Order Request Number:{' '}
                <span>
                  {' '}
                  <a className="redirect_link" href="javascript:void(0)" onClick={() => redirectToTMO({ orderId: leadId })}>
                    {leadId}
                  </a>
                </span>{' '}
                <br />
                {getMessageBody()}
              </p>
              <Button className="redirect_btn" onClick={redirectToTMODashboard()} displayName="Track Request" buttonClass="btn_outline" variant="outlinebtn" />
            </div>
            <div className="bottom-section">
              <div className="title">Request Details</div>
              <div className="content">
                <div className="box">
                  <span className="sub-heading">Number of Circuits</span>
                  <span className="value">{noOfCircuits || '-'}</span>
                </div>
                <div className="box">
                  <span className="sub-heading">Order ID</span>
                  <span className="value">{leadId || '-'}</span>
                </div>
                <div className="box">
                  <span className="sub-heading">Date &amp; time</span>
                  <span className="value">{convertTimeStamp(dateStamp) || '-'}</span>
                </div>
                {isUpgrade ? (
                  <div className="box">
                    <span className="sub-heading">Request Type</span>
                    <span className="value">Upgrade</span>
                  </div>
                ) : (
                  <div className="box">
                    <span className="sub-heading">Request Type</span>
                    <span className="value">New Order</span>
                  </div>
                )}
              </div>
            </div>
          </div>
          {userType !== 'KAM' && (
            <div className="thanks_right">
              <NextSteps />
            </div>
          )}
          <div className="explore_section">
            <h2 className="explore_head">Explore Other Products</h2>
            <ExploreProducts />
          </div>
          <div className="referBusiness">
            <ReferBusiness />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthThanksPage;
